import { defineStore } from 'pinia';
import axios from 'axios';
import { API_URL, error } from '~/utils';

export async function criarSenha(cmd) {
  const response = await axios.post(
    `${API_URL}/autenticacao/criar-senha`,
    cmd,
    {
      withCredentials: true,
      timeout: 120000,
    },
  );
  return response.data;
}

export const useStore = defineStore('criar-senha', {
  state: () => ({
    status: null,
    error: null,
    senha: null,
  }),
  actions: {
    async criarSenha(token) {
      this.status = 'loading';
      try {
        await criarSenha({
          token,
          senha: this.senha,
        });
        this.status = 'success';
      }
      catch (e) {
        this.error = error(e).error;
        this.status = 'error';
      }
    },
  },
});
